import { render } from "./NovelCell.vue?vue&type=template&id=0595d8b7&scoped=true&ts=true"
import script from "./NovelCell.vue?vue&type=script&lang=ts"
export * from "./NovelCell.vue?vue&type=script&lang=ts"

import "./NovelCell.vue?vue&type=style&index=0&id=0595d8b7&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0595d8b7"]])

export default __exports__